import axios from "axios";

export const getProjectSpecialStatusAPI = (id) => {
  return axios.get("/ppm/project/getProjectSpecialStatus?id=" + id);
};

export const getExecutersAPI = (obj) => {
  // return axios.get(`getExecuters${params()}`);
  return axios({
    url: `ppm/project/getExecuters`,
    method: `get`,
    params: obj,
  });
};

export const createProjectEcrChangeAPI = (obj) => {
  return axios.post(`/ppm/project/createProjectEcrChange`, obj);
};
